//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { removeTempToken, getTempToken } from '@/utils/auth'
import SubmitButton from '@/components/el-submit-button'
import PolicyItem from '@/components/el-policy-item'

// 微信开发调试
// import Cookies from 'js-cookie'
// let vconsole = null
// // 调试模式,则引入vconsole
// if (Cookies.get('x-debug') == 1 && (Cookies.get('prerelease') == 1 || process.env.NODE_ENV != 'production')) {
//   import('vconsole').then((vConsole) => {
//     vconsole = typeof vConsole === "function" ? new vConsole() : new vConsole.default()
//   })
// }

export default {
  name: 'common-footer',
  components: {SubmitButton, PolicyItem},
  data() {
    return {
      // click_count: 0,
      is_temp_login: false
    }
  },
  computed: {
    this_year() {
      return (new Date()).getFullYear()
    },
    is_prerelease() {
      return this.$store.state.app.is_prerelease
    },
  },
  methods: {
    goUserinfo() {
      if (this.$route.name != 'user_info') {
        this.$router.push({name: 'user_info', query: {from: 'footer'}})
      }
    },
    goHome() {
      /**
       * 根据不同身份跳转到不同页面
       * 班主任：班主任主页(个人主页)
       * 老师：  教师主页(个人主页)
       * 家委会：孩子信息页
       * 家长：  孩子信息页
       */
       if (this.$store.getters.has_teacher_role) {
        this.$router.push({name: 'admin_home', query: {from: 'footer'}})
       } else {
        this.$router.push({name: 'my_children', query: {from: 'footer'}})
       }
    },
    goMPLogs() {
      if (this.$store.getters.is_miniprogram) {
        this.$mpNavigateTo({
          url: '/pages/logs/index',
        })
      }
    },
    // 登出管理员当前登录的临时账户
    logoutTempUser() {
      this.$vux.confirm.show({
        title: '确定登出么',
        content: '登出后，将会刷新回到你自己的账户',
        onConfirm: () => {
          removeTempToken()

          if (!getTempToken()) {
            this.$vux.toast.text('登出成功,刷新页面...')
            console.log('logoutTempUser reload')
            this.$store.dispatch('reload')
          }
        }
      })
    },
  },
  mounted() {
    this.is_temp_login = !!getTempToken()
  }
}



// WEBPACK FOOTER //
// ./src/components/el-common-footer.vue